module.exports = __webpack_public_path__ + "img/icon2.83cae2e3.61740fbc.png";